import {
    FETCH_EMP_DISCRIPENCY_REQUEST,
    FETCH_EMP_DISCRIPENCY_SUCCESS,
    FETCH_EMP_DISCRIPENCY_FAILURE,
} from "../constants/EmpDiscripencyConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const EmpDiscripencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EMP_DISCRIPENCY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_EMP_DISCRIPENCY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_EMP_DISCRIPENCY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default EmpDiscripencyReducer;
